var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#2C2C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 5.3125C17.0938 5.6875 17.0938 6.34375 16.6875 6.71875L8.6875 14.7188C8.3125 15.125 7.65625 15.125 7.28125 14.7188L3.28125 10.7188C2.875 10.3438 2.875 9.6875 3.28125 9.3125C3.65625 8.90625 4.3125 8.90625 4.6875 9.3125L8 12.5938L15.2812 5.3125C15.6562 4.90625 16.3125 4.90625 16.6875 5.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/CheckedIcon.9cffd283bdec455cd1ff6f872a95e9d2.svg";
export { ForwardRef as ReactComponent };